import type { Client } from '../types';

export interface LeadRecommendation {
  short: string;
  detail: string;
}

export function getLeadRecommendation(client: Client): LeadRecommendation | null {
  const status = client.customerStatus || 'new';

  if (status === 'not_relevant') return null;

  if (status === 'deal_closed' || status === 'closed') {
    return {
      short: 'שלח הודעת תודה ובקש המלצה',
      detail: 'העסקה נסגרה. שלח הודעת תודה ללקוח ובקש המלצה לקולגות.',
    };
  }

  if (client.nextFollowUpAt) {
    const followUp = new Date(client.nextFollowUpAt).getTime();
    if (followUp < Date.now()) {
      return {
        short: 'בצע מעקב עכשיו — המועד למעקב עבר',
        detail: 'המועד שנקבע למעקב כבר עבר. יש ליצור קשר עם הלקוח בהקדם.',
      };
    }
  }

  if (client.nextAction) {
    return {
      short: `הפעולה הבאה: ${client.nextAction}`,
      detail: `הפעולה הבאה שנקבעה: ${client.nextAction}. יש לבצע אותה בהקדם.`,
    };
  }

  if (!client.lastContactAt) {
    return {
      short: 'צור קשר ראשוני עם הלקוח',
      detail: 'טרם נוצר קשר עם הלקוח. יש ליצור קשר ראשוני לברר צרכים.',
    };
  }

  const threeDaysMs = 3 * 24 * 60 * 60 * 1000;
  const lastContact = new Date(client.lastContactAt).getTime();
  if (Date.now() - lastContact > threeDaysMs) {
    return {
      short: 'להתקשר היום — לא נוצר קשר מעל 3 ימים',
      detail: 'לא נוצר קשר עם הלקוח מעל 3 ימים. מומלץ להתקשר היום.',
    };
  }

  if (status === 'serious') {
    return {
      short: 'לקוח רציני — קדם לשלב הבא',
      detail: 'הלקוח סומן כרציני. יש לקדם אותו לשלב הבא — הצעת נכסים או פגישה.',
    };
  }

  if (status === 'property_visit') {
    return {
      short: 'אשר ביקור ושלח פרטי נכס',
      detail: 'הלקוח בשלב ביקור בנכס. אשר את מועד הביקור ושלח פרטים רלוונטיים.',
    };
  }

  if (status === 'met') {
    return {
      short: 'שלח סיכום פגישה והמשך טיפול',
      detail: 'נפגשת עם הלקוח. שלח סיכום פגישה וקבע את הצעד הבא.',
    };
  }

  if (status === 'new') {
    return {
      short: 'צור קשר ראשוני',
      detail: 'ליד חדש. יש ליצור קשר ראשוני, להבין צרכים ולהציע התאמה.',
    };
  }

  return {
    short: 'בדוק מצב הלקוח וקבע פעולה הבאה',
    detail: 'אין המלצה ספציפית. בדוק את מצב הלקוח וקבע פעולה מתאימה.',
  };
}
